import script from "./ServerScheduledTasksTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerScheduledTasksTab.vue?vue&type=script&setup=true&lang=js"

import "./ServerScheduledTasksTab.vue?vue&type=style&index=0&id=f2268cac&lang=scss"

const __exports__ = script;

export default __exports__